import api from "@/config/api";
import type { RequestOptions } from "@/shared/types/api.types";
import type {
  ExtendMaintenanceDTO,
  MaintenancePaginationParams,
  MaintenancePageResponseDTO,
  MaintenanceResponseDTO,
} from "../types/maintenance.types";

export const maintenanceService = {
  listPaginated: (
    params?: MaintenancePaginationParams,
    options?: RequestOptions,
  ) =>
    api
      .get<MaintenancePageResponseDTO>("/maintenances/search", {
        params,
        signal: options?.signal,
      })
      .then((res) => res.data),

  finish: (id: number) =>
    api
      .patch<MaintenanceResponseDTO>(`/maintenances/${id}/finish`)
      .then((res) => res.data),

  extend: (id: number, data: ExtendMaintenanceDTO) =>
    api
      .patch<MaintenanceResponseDTO>(`/maintenances/${id}/extend`, data)
      .then((res) => res.data),
};
